/* eslint-disable max-len */
/**
 * French translations.
 */
export default {
  ACTION: {
    LINK_COPY: 'Copier'
  },
  ERROR: {},
  HEADER: {
    NAME: 'Nom',
    PROFIT_MARGIN: 'Pourcentage de commission'
  },
  LABEL: {
    GENERATE_LINK: 'Générer un lien',
    GENERATED_LINK: 'Lien généré',
    NAME: 'Nom',
    PROFIT_MARGIN: 'Pourcentage de commission'
  },
  SENTENCE: {},
  SUCCESS: {
    LINK_COPIED: 'Lien copié'
  },
  TOOLTIP: {
    NAME: 'Nom',
    PROFIT_MARGIN: 'Pourcentage de commission'
  }
};
